$(document).on('turbo:load', () => {
  if ($('#user-referrer-field').length) {
    if (document.cookie.includes("_gb_user_referrer")) {
      var spl = document.cookie.split(";");
      for (var i = 0; i < spl.length; i++) {
        var nameAndVal = spl[i];
        var nameAndValSpl = nameAndVal.split("=");
        var name = nameAndValSpl[0].trim();
        if (name === "_gb_user_referrer") {
          var val = nameAndValSpl[1].trim();
          $('#user-referrer-field').val(val);
        }
      }
    }
  }

  // if we have the referral promo clock, use it
  if ($('#covid-signup-form-referral-time-left').length) {
    var endDate = new Date("2022-02-05T13:00:00+00:00");
    var now = new Date();
    var millisDifference = endDate - now;

    if (millisDifference <= 0) {
      $('#covid-signup-form-referral-promo').hide();
    } else {
      var hours = Math.floor(millisDifference / 1000 / 60 / 60);
      var minutes = Math.round(((millisDifference / 1000 / 60 / 60) - hours) * 60);

      $('#covid-signup-form-referral-time-left-hours').text(hours);
      $('#covid-signup-form-referral-time-left-minutes').text(minutes);

    }
  }
});
